import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// OBTIENE TODA LA INFORMACION DE LOS PRODUCTOS
export const getEstadosPurchase = async () => {
    const respuesta = PrivateInterceptor('status/Purchase', 'GET')
    return respuesta
};

// OBTENER TODOS LOS ESTADOS Security
export const getEstadosSecurity = async () => {
    const respuesta = PrivateInterceptor('IT/Status', 'GET')
    return respuesta
}

export const getEstadosCategory = async (StatusCategory) => {
    const respuesta = PrivateInterceptor(`IT/Status/StatusCategory/${StatusCategory}`, 'GET');
    return respuesta;
}

// OBTENER TODOS LOS ESTADOS Security
export const getEstadosSalidaTelaCruda = async () => {
    const respuesta = PrivateInterceptor('status/SalidaTelaCruda', 'GET')
    return respuesta
}


export const getStatusPurchaseDetails = async () => {
    const respuesta = await PrivateInterceptor('status/PurchaseDetails', 'GET');
    return respuesta;
}

export const GuardarEstados = async (Datos) => {
    const respuesta = PrivateInterceptor(`IT/Status/GuardarEstado`, 'POST', {Datos});
    return respuesta;
}

export const EditarEstados = async (Datos) => {
    const respuesta = PrivateInterceptor(`IT/Status/EditarEstado`, 'POST', {Datos});
    return respuesta;
}
